import { render, staticRenderFns } from "./seckillList.vue?vue&type=template&id=56d30e67&scoped=true"
import script from "./seckillList.vue?vue&type=script&lang=js"
export * from "./seckillList.vue?vue&type=script&lang=js"
import style0 from "./seckillList.vue?vue&type=style&index=0&id=56d30e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d30e67",
  null
  
)

export default component.exports